import type { LoadableComponent } from '@loadable/component';
import type { RouteProps } from 'react-router';

import { Route } from 'src/shared/route';

export interface HomeownerRouteDescriptor
  extends Required<Pick<RouteProps, 'exact' | 'path'>> {
  component: LoadableComponent<{}>;
}

export type RouteMap = Record<string, HomeownerRouteDescriptor>;

export const customizeRoutes = [
  Route.HOMEOWNER_APP_PAINT_WALLS_DISPLAY_IMAGE.path,
  Route.HOMEOWNER_APP_CUSTOMIZE.path,
];

export const fullscreenImageRoutes = [
  Route.HOMEOWNER_APP_FAVORITES_DISPLAY_FULLSCREEN.path,
  Route.HOMEOWNER_APP_ORIGINAL_DISPLAY_FULLSCREEN.path,
  Route.HOMEOWNER_APP_PROJECT_DISPLAY_FULLSCREEN.path,
];

/**
 * Routes with content that fills the screen
 */
export const fullscreenRoutes = [...customizeRoutes, ...fullscreenImageRoutes];
